module.exports = __webpack_public_path__ + "static/assets/sprite.2a250866.svg";